module.exports = __webpack_public_path__ + "static/media/bm.0f6cf028.svg";